import MaintenancePage from "../MaintenancePage";
import resource from "../../resources/trainingResource";

export default function Trainings() {
    return <MaintenancePage resource={resource} />;
}
